import { BasicSerializedWidget } from './types'

export function getConfig(
  serialized: BasicSerializedWidget,
): Record<string, any> | null | undefined {
  return serialized.config || serialized
}
